import { z } from "zod"

export type HUImage = z.infer<typeof HUImageSchema>

export const HUImageSchema = z
  .object({
    url: z.string(),
    hash: z.string(),
    key: z.string().nullish(),
  })
  .meta({ id: "HUImageSchema" })
